import React from "react";

export default function CountdownTimer({
  hours,
  minutes,
  seconds,
  hoursLabel = "Hours",
  minutesLabel = "Minutes",
  secondsLabel = "Seconds",
  caption,
  className = "",
}) {
  const cells = [
    { value: hours, label: hoursLabel },
    { value: minutes, label: minutesLabel },
    { value: seconds, label: secondsLabel },
  ];
  const inlineTime = `${hours}:${minutes}:${seconds}`;

  return (
    <>
      <div
        className={`hidden sm:flex items-center gap-3 flex-wrap ${className}`}
      >
        {cells.map((c) => (
          <div
            key={c.label}
            className="flex flex-col items-center gap-1.5 flex-[1_1_68px] min-w-[64px] py-3.5 px-2 rounded-2xl bg-white border border-[#F2D7CE]"
          >
            <span className="font-bold text-[30px] leading-none text-brand-orange tabular-nums">
              {c.value}
            </span>
            <span className="text-xs tracking-[0.08em] uppercase text-text-light">
              {c.label}
            </span>
          </div>
        ))}
        {caption && (
          <span className="text-sm text-text-light max-w-[16ch] leading-[1.4] flex-[1_1_120px]">
            {caption}
          </span>
        )}
      </div>

      <div className="flex sm:hidden items-baseline justify-center text-center gap-2.5 flex-wrap py-3.5 px-[18px] rounded-2xl bg-white border border-[#F2D7CE]">
        <span className="font-bold text-[30px] leading-none text-brand-orange tabular-nums tracking-[0.02em]">
          {inlineTime}
        </span>
        {caption && (
          <span className="text-sm text-text-light leading-[1.4]">
            {caption}
          </span>
        )}
      </div>
    </>
  );
}
